// Both come straight off a payload where they are nullable, so null is part of
// what a caller has to pass rather than something each one converts.
type TeamHistoryItemProps = {
  seasonName?: string | null;
  teamName?: string | null;
};

const TeamHistoryItem = ({ seasonName, teamName }: TeamHistoryItemProps) => (
  <div className="border-t border-separator px-2 py-3 first:border-t-0">
    <div className="flex items-baseline gap-2">
      <span className="min-w-0 flex-1 wrap-break-word text-sm">{teamName}</span>
      <span className="shrink-0 whitespace-nowrap text-xs text-muted tabular-nums">
        {seasonName}
      </span>
    </div>
  </div>
);

export default TeamHistoryItem;
